import { useState, useContext, useEffect, useTransition, useOptimistic } from "react";
import axios from "axios";
import { format } from "date-fns";
import CookieContext from "../contexts/CookieContext";
import AppContext from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

// Table関連
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, } from '@mui/material';
// import { TableVirtuoso } from 'react-virtuoso';

// Dialog関連
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
import { CircularProgress, Chip, Box, Switch, Checkbox } from '@mui/material';

import { DataGrid, gridClasses } from '@mui/x-data-grid';

const columns = [
  { field: 'id' },
  { field: 'name' },
  { field: 'is_checked' },
  { field: 'checked_datetime' },
  // { field: 'score', type: 'number', width: 200, valueFormatter: (value) => `${value}` },
];

const StyledButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #32dae6)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const StyledButtonLogLists = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #32e647)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const Checklist = () => {
  // const { apiUserHost, } = useContext(AppContext);
  const { cookies } = useContext(CookieContext);
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'checklist/';
  const [loading, setLoading] = useState(true);

  // const [disabled, setDisabled] = useState(true);
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);

  const [refresh, setRefresh] = useState(false);
  const [error, setError] = useState();
  const [checklists, setChecklists] = useState([]);
  const [recordChecklists, setRecordChecklists] = useState([]);
  const [logs, setLogs] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [dataId, setDataId] = useState('-');
  const [dataName, setDataName] = useState();

  const [circularProgressOpen, setCircularProgressOpen] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertId, setAlertId] = useState('');
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const [recordOpen, setRecordOpen] = useState(false);
  const [recordId, setRecordId] = useState('');
  const [recordTitle, setRecordTitle] = useState('');
  const [recordMessage, setRecordMessage] = useState('');

  const [optimisticData, addOptimisticData] = useOptimistic(
    { id: '', is_checked: '', check_datetime: '' },
    (prevData, newData) => ({ ...prevData, ...newData })
  );

  const weekDay = [
    '<font color="#ff0000">日</font>',
    '<font color="#003f00">月</font>',
    '<font color="#437943">火</font>',
    '<font color="#003f00">水</font>',
    '<font color="#003f00">木</font>',
    '<font color="#003f00">金</font>',
    '<font color="#0000ff">土</font>',
  ]

  const [isPending, startTransition] = useTransition();

  const handleAlertOpen = (id, title, message) => {
    setAlertId(id);
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  }

  const handleAlertClose = () => {
    setAlertOpen(false);
  }


  const handleRecordOpen = (record_id) => {
    // alert(record_id);
    setCircularProgressOpen(true);
    // setRefresh(true);
    // setLoading(true)

    const recordDetail = async () => {
      // リフレッシュのための値を初期化
      // setRefresh(false);
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }
  
          const response = await fetch(`${apiHost}${basePath}record/${record_id}/`, {headers});
          setRecordMessage('')
  
          if (response.status === 200) {
            const data = await response.json();

            // レコード表示用html組立

            let recordDetail = ''
            
            // {/* データリスト */}
            recordDetail += '<TableContainer>'
            recordDetail += '  <Table aria-label="simple table">'
            recordDetail += '    <TableHead>'
            recordDetail += '      <TableRow>'
            recordDetail += '        <TableCell>ID</TableCell>'
            recordDetail += '        <TableCell>チェック項目</TableCell>'
            recordDetail += '        <TableCell align="left">チェック</TableCell>'
            recordDetail += '        <TableCell align="left">チェック日時</TableCell>'
            recordDetail += '      </TableRow>'
            recordDetail += '      <br />'
            recordDetail += '    </TableHead>'
            recordDetail += '    <TableBody>'
            
            {data.map((row, index) => {
              recordDetail += '      <TableRow key=' + row.id + '>'
              recordDetail += '        <TableCell component="th" scope="row">' + row.id + '</TableCell>'
              recordDetail += '        <TableCell align="left">' + row.name + '</TableCell>'
              recordDetail += '        <TableCell align="left"><Checkbox checked=' + row.is_checked + ' />' + row.is_checked.toString() + '</TableCell>'
              recordDetail += '        <TableCell align="left">' + row.checked_datetime + '</TableCell>'
              recordDetail += '      </TableRow>'
              recordDetail += '      <br />'
            })}

            recordDetail += '    </TableBody>'
            recordDetail += '  </Table>'
            recordDetail += '</TableContainer>'
                        
            setRecordMessage(recordDetail)
          }
          else if (response.status === 401) {
            setError('ログインしてください');
          }
          else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }

        // setRefresh(true);
        // setLoading(false);

      } catch (err) {
        console.log(err);
      } finally {
        setCircularProgressOpen(false);
        // setRecordMessage('');
        setRecordOpen(true);
      }

  
    // setLogTitle(title);
    // setLogMessage(message);
    }
  recordDetail();
  setRecordId(record_id);
}

  const handleRecordClose = () => {
    setRecordOpen(false);
  }

  // データ更新用
  useEffect(() => {
    fetchchecklists();
    fetchrecordchecklists();
  }, [refresh]);

  const recordPost = async () => {
    setCircularProgressOpen(true);
    // リフレッシュのための値を初期化
    setRefresh(false);

    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(`${apiHost}${basePath}record/`, 
          {
            name: 'noname',
          },
          {headers},
        )

        if (response.status === 201) {
          handleAlertOpen(response.data.id, 'リセット', 'リセットが完了しました');
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    } finally {
      setCircularProgressOpen(false);
    }
  }

  const fetchchecklists = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setChecklists(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
      setRefresh(true);
      setLoading(false);

    } catch (err) {
      console.log(err);
    }
  }

  const fetchrecordchecklists = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(`${apiHost}${basePath}recordlists/`, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setRecordChecklists(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
      setRefresh(true);
      setLoading(false);

  } catch (err) {
      console.log(err);
    }
  }

  const retrieveData = async(pk) => {
    try {
      if (cookies.jwtAccess) {
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await fetch(`${apiHost}${basePath}${pk}/`, {headers});
        // fetch成功時、status200
        if (response.status === 200) {
          const data = await response.json();

          document.getElementById('name').value = data.name;
          document.getElementById('id').value = data.id;

          setDataId(pk);
          setDataName(data.name);
          setUpdateDisabled(false);
          setDeleteDisabled(false);
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }

      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const resetData = async() => {
    try {
      document.getElementById('name').value = '';
      setDataId('');
      setDataName('');

      setUpdateDisabled(true);
      setDeleteDisabled(true);
    } catch (err) {
      console.log(err);
    }
  }

  const createData = async () => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        var postData = {
          name: "新規",
          jwt_access: cookies.jwtAccess,
          access_token_username: cookies.accessTokenUsername,
          user: cookies.accessTokenUserId,
        }

        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(apiHost + basePath, postData, {headers});
        // post成功時、status201
        if (response.status === 201) {
          handleAlertOpen(response.data.id, 'データ追加', 'データ追加が完了しました');
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const updateData = async (data) => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        startTransition(async () => {
          const response = await axios.put(`${apiHost}${basePath}${dataId}/`, 
            {
              name: dataName,
            },
            {headers},
          )

          if (response.status === 200) {
            handleAlertOpen(response.data.id, 'データ更新', 'データ更新が完了しました');
            resetData();
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        });
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const deleteData = async () => {
    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.delete(`${apiHost}${basePath}${dataId}/`, {headers})
        // delete成功時、status204
        if (response.status === 204) {
          handleAlertOpen(dataId, 'データ削除', 'データ削除が完了しました');
          resetData();
        } else if (response.status === 401){
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
        console.log(err);
    };
  }

  const check = async (pk) => {

    startTransition( async () => {
      alert(pk)
      // 楽観的な更新を適用
      addOptimisticData({
        name: '更新中',
        is_checked: false,
        checked_datetime: pk,
      });  
    })

    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await axios.put(`${apiHost}${basePath}check/${pk}/`, 
          {
            // name: dataName,
          },
          {headers},
        )

        if (response.status === 200) {
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const reload = () => {
    window.location.reload();
  }

  if(loading) return <p>Loading...</p>;
  if(error) return <><p className="errMsg">Error: {error ? error : error.message}<a href="">[再読込]</a></p><StyledButton onClick={reload}>再読込</StyledButton></>;

  // const rows = Array.from({ length: 200}, (_, index) => createData(index));

  const sampleData = JSON.stringify({
    name: "Irakli",
    messages: ["Hello", "Goodbye", "good day"],
    age: 24
})

  return (
    <>
      <div><StyledButton onClick={recordPost}>完了</StyledButton></div>
      <div>
        {Array.isArray(recordChecklists)
          ? recordChecklists.map((recordChecklist, index) => {
            // const parseJSON = JSON.parse(logChecklist.logchecklist);
            // console.log(parseJSON)
            return (
              <p>
                <StyledButtonLogLists onClick={() => {handleRecordOpen(recordChecklist.id)}}>
                【{recordChecklist.id}】
                {format(recordChecklist.created_at, "yyyy-MM-dd HH:mm:ss")}
                </StyledButtonLogLists>
              </p>
            )
          })
          : null
        }
      </div>

      {/* データリスト */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>,
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>チェック項目</TableCell>
              <TableCell align="left">チェック（switch）</TableCell>
              <TableCell align="left">チェック（checkbox）</TableCell>
              <TableCell align="left">チェック日時</TableCell>
              <TableCell align="center">曜日</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {checklists.map((row, index) => (
              <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">{row.id}</TableCell>
                <TableCell align="left"><Chip key={row.id} label={row.name} color="primary" onClick={() => {retrieveData(row.id)}} /></TableCell>
                <TableCell align="left"><Switch key={row.id} checked={row.is_checked} onClick={() => {check(row.id)}} />{row.is_checked.toString()}</TableCell>
                <TableCell align="left"><Checkbox key={row.id} checked={row.is_checked} onClick={() => {check(row.id)}} />{row.is_checked.toString()}</TableCell>
                <TableCell align="left">{row.checked_datetime}</TableCell>
                {/* <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} /> で、HTMLタグを有効にする */}
                {/* 平日：緑、土曜日：青、日曜日：赤 */}
                { row.is_checked == true ?
                  <TableCell align="center" dangerouslySetInnerHTML={{ __html: weekDay[new Date(row.checked_datetime).getDay()]}} /> :
                  <TableCell align="center">ー</TableCell>
                }
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


      <div><StyledButton onClick={createData}>データ追加</StyledButton></div>

        {/* データリスト */}
        {/* {Array.isArray(checklists)
          ? checklists.map((checklist, index) => {
            return <AppButton key={index} onClick={() => {retrieveData(checklist.id)}}>【{checklist.id}】{checklist.name}</AppButton>
          })
          : null
        } */}

      <div className="bd-callout bd-callout-warning">
        <form>
          <Chip label= {` ID : ${dataId} `} id="id" variant="outlined" />
          <label htmlFor="name" style={{margin:"0.5rem", padding:"0.5rem"}}>名前</label>
          <input id="name" type="text" disabled={updateDisabled} {
            ...register('name',
              {
                onChange: (e) => setDataName(e.target.value)
              }
            )} />
          <p className="ErrMsg">{errors.name?.message}</p>
        </form>

      <div><AppButton key={dataId} disabled={updateDisabled} onClick={() => {updateData()}}>更新</AppButton></div>
      <div><AppButton key={dataId} disabled={deleteDisabled} onClick={() => {deleteData()}}>削除</AppButton></div>

      {/* DataGrid */}
      <Box
        sx={{
          // height: 500,
          // width: '100%',
          [`.${gridClasses.cell}.checked`]: {
            backgroundColor: '#b9d5ff91',
            color: '#1a3e72',
          },
          [`.${gridClasses.cell}.unchecked`]: {
            backgroundColor: '#ff943975',
            color: '#1a3e72',
          },
        }}
        >
        <DataGrid
          autosizeOnMount
          autosizeOptions={{
            // Autosizingに使用するカラム
            columns: ['id', 'name', 'is_checked', 'checked_datetime'],
            // Header部分及びdata部分のそれぞれの文字列の長さにより、幅を自動調整するかどうかの設定
            includeHeaders: true,
            includeOutliers: true,
          }}
          sx={{
            m: 2,
            boxShadow: 2,
            border: 2,
          }}
          rows={checklists}
          columns={columns}
          getCellClassName={(params) => {
            // if (params.value === 'true') {
            if (params.field === 'is_checked' && params.value === true) {
              return 'checked';
            } else if (params.field === 'is_checked' && params.value === false) {
              return 'unchecked';
            } else {
              return '';
            }
          }}
        />
      </Box>

        <Dialog
          open={circularProgressOpen}
          aria-labelledby="circular-progress-dialog-title"
          aria-describedby="circular-progress-dialog-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="circular-progress-dialog-title">
            Loading...
          </DialogTitle>
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>

        <Dialog
          open={alertOpen}
          onClose={handleAlertClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            【{alertId}】{alertTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {alertMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <AppButton onClick={handleAlertClose} autoFocus>OK</AppButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={recordOpen}
          onClose={handleRecordClose}
          aria-labelledby="record-dialog-title"
          aria-describedby="record-dialog-description"
        >
          <DialogTitle id="record-dialog-title">
            【{recordId}】{recordTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="record-dialog-description" dangerouslySetInnerHTML={{ __html: recordMessage}} />
          </DialogContent>
          <DialogActions>
            <AppButton onClick={handleRecordClose} autoFocus>OK</AppButton>
          </DialogActions>
        </Dialog>

      </div>

      {/* <div>
        {Array.isArray(logChecklists)
          ? logChecklists.map((logChecklist, index) => {
            return <AppButton key={index} onClick={() => {retrieveData(logChecklist.id)}}>【{logChecklist.id}】{logChecklist.logchecklist}</AppButton>
          })
          : null
        }
      </div> */}

      {/* <div>
        {Array.isArray(logChecklists)
          ? logChecklists.map((logChecklist, index) => {
            return (
              <p>
                {JSON.parse(logChecklist.id)}
                {logChecklist.logchecklist}
              <br /><br /></p>
            )
          })
          : null
        }
      </div> */}
    </>
  )
}
export default Checklist
